import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { LayoutHeaderFooterRenderComponent } from './layout-header-footer-render.component';


export const components = [
  LayoutHeaderFooterRenderComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  declarations: components
})
export class LayoutHeaderFooterRenderModule {}

export default components;
